import { createContext, useContext } from 'react';

interface StaggerContextValue {
  index: number;
  delayStep: number;
}

const StaggerContext = createContext<StaggerContextValue | null>(null);

export const StaggerProvider = StaggerContext.Provider;

export function useStaggerContext(): StaggerContextValue | null {
  return useContext(StaggerContext);
}
